const FOCUS_MAIN_KEY = 'fe-frame-global-search-focus-main'

export function rememberSearchResultNavigation() {
  try {
    sessionStorage.setItem(FOCUS_MAIN_KEY, '1')
  } catch {
    // Private mode can block storage. Navigation still proceeds.
  }
}

function findFocusTarget() {
  const main =
    document.getElementById('the-main-content') || document.querySelector('main, [role="main"]')
  const scope = main || document.body

  return scope.querySelector('h1') || main
}

function focusTarget(target) {
  if (!target) return false
  if (!target.hasAttribute('tabindex')) {
    target.setAttribute('tabindex', '-1')
  }
  target.focus()
  return document.activeElement === target
}

export function focusContentAfterSearchNavigation() {
  let shouldFocus = false
  try {
    shouldFocus = sessionStorage.getItem(FOCUS_MAIN_KEY) === '1'
    if (shouldFocus) sessionStorage.removeItem(FOCUS_MAIN_KEY)
  } catch {
    return
  }
  if (!shouldFocus) return

  const attempt = () => focusTarget(findFocusTarget())
  if (attempt()) return
  window.setTimeout(attempt, 0)
  window.setTimeout(attempt, 300)
}
